<template>
  <div class="flex gpx-albums-layout-wrapper">
    <div v-if="$slots.sidebar" class="gpx-albums-layout-sidebar">
      <slot name="sidebar" />
    </div>

    <div class="gpx-albums-layout-content-container w-full">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.gpx-albums-layout-wrapper {
  display: flex;
  flex-direction: column;
}

.gpx-albums-layout-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

@media (width >= 768px) {
  .gpx-albums-layout-wrapper {
    display: grid;
    grid-template-columns: fit-content(100%) auto;
  }

  .gpx-albums-layout-content-container {
    overflow: auto;
  }

  .gpx-albums-layout-content-container,
  .gpx-albums-layout-sidebar {
    height: calc(100vh - var(--gpx-navbar-height));
  }

  .gpx-albums-layout-sidebar {
    display: flex;
  }
}
</style>
